import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { TaskDescriptionField } from '../../../../../clients/sidebar/components/RichTextDescription/TaskDescriptionField';
import OriginalTextFromSelection from '../../../../../clients/sidebar/components/OriginalTextFromSelection';
import styles from './index.module.css';
import { accessTo } from 'appJS/models/Access';
import Title from 'BugHerdClient/sidebar/views/SidebarPanel/Detailbar/Title';

export default class DetailsHead extends React.Component {
  static propTypes = {
    createdAt: PropTypes.string,
    setProperty: PropTypes.func.isRequired,
    url: PropTypes.string,
    canEditDescription: PropTypes.bool,
    taskId: PropTypes.number.isRequired,
    localTaskId: PropTypes.number.isRequired,
    column: PropTypes.shape({
      status_id: PropTypes.number,
      id: PropTypes.number,
      name: PropTypes.string
    }).isRequired,
    priorityId: PropTypes.number.isRequired,
    projects: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        id: PropTypes.number,
        updated_at: PropTypes.string
      })
    ),
    title: PropTypes.string,
    description: PropTypes.string,
    fullstorySessionUrl: PropTypes.string,
    destinations: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.string,
        status_id: PropTypes.oneOfType([PropTypes.object, PropTypes.number]),
        position: PropTypes.number
      })
    ),
    creator: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        email: PropTypes.string,
        display: PropTypes.string
      })
    ]),
    closeDetailBar: PropTypes.func,
    toggleExpandedView: PropTypes.func,
    deleteTask: PropTypes.func,
    canDeleteTask: PropTypes.bool,
    moveToProject: PropTypes.func,
    canMoveToProject: PropTypes.bool,
    editStatus: PropTypes.bool,
    markAsStatus: PropTypes.func,
    toggleFullScreenView: PropTypes.func,
    container: PropTypes.instanceOf(Element),
    projectId: PropTypes.number,
    taskDescriptionRichText: PropTypes.shape({
      shortcutConfig: PropTypes.object,
      mentionPreviewContext: PropTypes.object
    }),
    secretId: PropTypes.string.isRequired,
    bugherdUrl: PropTypes.string.isRequired,
    isAdminView: PropTypes.bool.isRequired,
    className: PropTypes.string,
    showTaskActions: PropTypes.bool,
    taskActions: PropTypes.func,
    taskPromptActions: PropTypes.node,
    aiSuggestedTitle: PropTypes.bool,
    originalCopyText: PropTypes.string,
    isExpandedView: PropTypes.bool
  };

  static defaultProps = {
    isPlaceholder: false
  };

  componentWillUnmount() {
    this.isSmallDetailsView.removeListener(this.setSmallDetailsView);
  }

  UNSAFE_componentWillMount() {
    this.isSmallDetailsView = window.matchMedia(
      '(min-width: 951px) and (max-width: 1359px)'
    );
    this.setSmallDetailsView(this.isSmallDetailsView);
    this.isSmallDetailsView.addListener(this.setSmallDetailsView);
  }

  updateTaskDescription = description =>
    this.props.setProperty({ description });
  updateTaskStatus = column => this.props.markAsStatus(column);

  setSmallDetailsView = evt => {
    this.setState({
      isSmallDetailsView: evt.matches
    });
  };

  render() {
    const {
      taskId,
      title,
      description,
      canEditDescription,
      projectId,
      taskDescriptionRichText,
      showTaskActions,
      taskActions,
      aiSuggestedTitle,
      originalCopyText,
      isExpandedView
    } = this.props;

    const { updateTaskDescription } = this;

    return (
      <div
        className={cx(styles.container, this.props.className, {
          [styles.hideTaskActions]: !showTaskActions
        })}
      >
        <div
          className={cx(styles.descriptionContainer, {
            [styles.isExpandedView]: !showTaskActions
          })}
        >
          {!originalCopyText?.trim() && (
            <Title
              {...{
                title,
                canEditTitle: canEditDescription,
                updateTitle: (
                  title: string,
                  aiSuggestedTitle: boolean,
                  titleSuggestion: boolean
                ) =>
                  this.props.setProperty({
                    title,
                    ai_suggested_title: aiSuggestedTitle,
                    title_suggestion: titleSuggestion
                  }),
                taskId,
                projectId,
                description,
                canUseAiSuggestedTitles: accessTo('ai_suggested_titles'),
                aiSuggestedTitle,
                hasSelectedText: !!originalCopyText
              }}
            />
          )}
          <OriginalTextFromSelection selectedText={originalCopyText} />
          <TaskDescriptionField
            footerActions={this.props.taskPromptActions}
            value={description}
            onChange={updateTaskDescription}
            mode="details"
            editable={canEditDescription}
            fullHeight={isExpandedView}
            getContainer={() => this.props.container}
            shortcutConfig={taskDescriptionRichText?.shortcutConfig ?? null}
            mentionPreviewContext={
              taskDescriptionRichText?.mentionPreviewContext ?? {
                descriptionMarkdown: description
              }
            }
          />
        </div>
        {showTaskActions && taskActions()}
      </div>
    );
  }
}
